module.exports = __webpack_public_path__ + "img/DE03749.7ef54a34.png";